import {residentPortalApi as api, User} from '../residentPortalApi';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import type {RootState} from '../store'
import { clearToken, setNativeToken } from '../../utils/tokenStorage';

const clearJwtCookie = () => {
    document.cookie = "jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    const host = window.location.hostname;
    document.cookie = `jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${host};`;
    if (host.includes('.')) {
        const rootDomain = host.split('.').slice(-2).join('.');
        document.cookie = `jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${rootDomain};`;
    }
}

interface initialStateInterface {
    loginModalOpen: boolean;
    authState: 'login' | 'reset' | 'create';
    authMessage: string;
    initialEmail: string;
    user: User | null;
    showCompleteProfileBanner: boolean;
    showVerifyEmailBanner: boolean;
}

const initialState:initialStateInterface = {
    loginModalOpen: false,
    authState: 'login',
    authMessage: '',
    initialEmail: '',
    user: null,
    showCompleteProfileBanner: true,
    showVerifyEmailBanner: true
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        openLoginModal(state) {
            state.loginModalOpen = true;
        },
        closeLoginModal(state) {
            state.loginModalOpen = false;
            state.authMessage = '';
        },
        setAuthState(state, action) {
            state.authState = action.payload;
        },
        setAuthMessage(state, action) {
            state.authMessage = action.payload;
        },
        setInitialEmail(state, action) {
            state.initialEmail = action.payload;
        },
        setUser(state, action) {
            state.user = action.payload
        },
        clearSession(state) {
            clearJwtCookie();
            clearToken(); // also wipes @capacitor/preferences on native
            state.user = null;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
        api.endpoints.postUsersLogin.matchFulfilled,
        (state, { payload }) => {
            if (payload?.previousToken) {
                void setNativeToken(payload.previousToken);
            }
            state.user = payload;
        }
        );
        builder.addMatcher(
        api.endpoints.getUsersMe.matchFulfilled,
        (state, {payload}) => {
            state.user = payload;
        });
        builder.addMatcher(
          api.endpoints.postUsersLogout.matchFulfilled,
          (state) => {
              clearJwtCookie();
                            clearToken();
              state.user = null;
          });
    },
})


export const logoutUser = createAsyncThunk('users/logout', async (payload: void, {dispatch}) => {
    try {
        const result = dispatch(api.endpoints.postUsersLogout.initiate());
        await result;
    } catch (error) {
        console.error('Error during logout:', error);
    } finally {
        dispatch(authSlice.actions.clearSession());
        dispatch(api.util.resetApiState());
    }
});

export const selectCurrentUser = (state: RootState) => state.auth.user

export default authSlice;
